export type TMobileCellRole = 'title' | 'index' | 'actions';

const indexLabelPattern = /^(#|№|no\.?)$/i;
const titleLabelPattern = /\b(name|title)\b/i;
const actionsLabelPattern = /\bactions?\b/i;

export const getMobileCellRole = (label: string, column: number, hasTitle: boolean): TMobileCellRole | undefined => {
  if (column < 2 && indexLabelPattern.test(label)) {
    return 'index';
  }
  if (column < 2 && !hasTitle && titleLabelPattern.test(label)) {
    return 'title';
  }
  if (actionsLabelPattern.test(label)) {
    return 'actions';
  }
  return undefined;
};
